import { useMemo } from 'react'

import { buildProductLayout } from '../utils/buildProductLayout.js'

/**
 * useProductLayout — resolves ProductView pane layout from panel settings + capabilities.
 *
 * Reads flat keys: panelSettings.unit_sheet_layout_desktop / unit_sheet_layout_mobile
 *
 * @param {object|null} panelSettings
 * @param {object|null} capabilities
 * @returns {{desktopPaneOrder: array, mobilePaneOrder: array, stickyPanes: Set, hiddenPanes: Set}}
 */
export function useProductLayout(panelSettings, capabilities) {
  return useMemo(
    () => buildProductLayout({
      unitSheetLayoutDesktop: panelSettings?.unit_sheet_layout_desktop ?? null,
      unitSheetLayoutMobile: panelSettings?.unit_sheet_layout_mobile ?? null,
      capabilities,
    }),
    [panelSettings, capabilities],
  )
}
